import { AsyncPipe, NgIf } from '@angular/common';
import { Component, OnInit, ViewChild, ViewContainerRef, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';
import { PagopaService, Pagamento } from 'app/services/pagopa.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'alert-attenzione',
    template: `

  <div class="flex flex-col p-4 mb-8 border-s-2  max-w-full border-amber-600">
        <div class="flex items-center">
            <mat-icon [svgIcon]="'heroicons_outline:megaphone'"></mat-icon>
            <span class="text-base uppercase font-semibold text-amber-600 leading-5 ml-2">ATTENZIONE</span>
        </div>
        <div class="mt-2 mb-4 text-base text-start justify-center text-secondary"> Le informazioni che hai fornito hanno valore di dichiarazione.<br/> Verifica che siano corrette.</div>

        <ng-container *ngIf="(pagamenti$ | async) as pagamenti">
        <div *ngIf="pagamenti?.length && model.usermode == 'spid'" class="mt-2 mb-4 text-base text-start justify-center text-secondary">Procedendo al pagamento non si potranno più modificare le informazioni.</div>
        </ng-container>
    </div>

  `,
    standalone: true,
    imports: [FormlyModule, MatIconModule, NgIf, AsyncPipe]
})
export class AlertAttenzioneComponent extends FieldWrapper implements OnInit{

  pagamentiTotali:number = 0;
  pagamenti$: Observable<Pagamento[]>;
  private _pagopaService = inject(PagopaService);


  ngOnInit(): void {

    this.pagamenti$ = this._pagopaService.pagamenti$;


    this.pagamentiTotali = (this.model.pagamenti && this.model.pagamenti.length) || 0;

  }


}
